import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { mediaUrlForPlayback } from '@/lib/mediaUrls';
import { buildMultishotSelectionRows } from '@/lib/songMultishotSelection';

/**
 * Per-stanza checklist: master + multishot alternates included on the video timeline.
 */
export function SongMultishotTimelinePicker({
  scene,
  disabled = false,
  onToggleMaster,
  onToggleShot,
}) {
  const rows = buildMultishotSelectionRows(scene);
  if (rows.length <= 1) return null;

  return (
    <div
      className="mt-3 rounded-lg border p-3 space-y-2"
      style={{ borderColor: 'var(--glass-border)', background: 'var(--bg-tertiary)' }}
      data-testid={`multishot-timeline-picker-${scene.id}`}
    >
      <div className="flex items-center justify-between gap-2">
        <Label className="text-xs font-semibold" style={{ color: 'var(--text-primary)' }}>
          Timeline images
        </Label>
        <span className="text-[10px]" style={{ color: 'var(--text-tertiary)' }}>
          Checked = shown on editor timeline
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {rows.map((row) => (
          <label
            key={row.key}
            className={`flex items-start gap-2 rounded-md border p-2 cursor-pointer transition-opacity ${row.enabled ? '' : 'opacity-55'}`}
            style={{ borderColor: 'var(--glass-border)', background: 'var(--bg-secondary)' }}
          >
            <Checkbox
              checked={row.enabled}
              disabled={disabled}
              onCheckedChange={(checked) => {
                if (row.kind === 'master') {
                  onToggleMaster?.(Boolean(checked));
                } else {
                  onToggleShot?.(row.shotIndex, Boolean(checked));
                }
              }}
              className="mt-0.5"
              data-testid={`multishot-toggle-${scene.id}-${row.key}`}
            />
            <div className="min-w-0 flex-1">
              {row.url ? (
                <img
                  src={mediaUrlForPlayback(row.url)}
                  alt=""
                  className="w-full h-14 object-cover rounded mb-1"
                />
              ) : null}
              <span className="text-[10px] font-medium block truncate" style={{ color: 'var(--text-primary)' }}>
                {row.label}
              </span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
